module.exports = __webpack_public_path__ + "static/psychic-interior-01-9be7d7e7b86e9ccd9003e46a6f5605aa.jpg";